import React from 'react'
import GenericGrid from '../../../sharedcomponents/5templates/commonGrid/GenericGrid'
import GridWrapper from '../../../sharedcomponents/5templates/commonGrid/GridWrapper'
import useGridWrapper from '../../../sharedcomponents/5templates/commonGrid/useGridWrapper'
import useService from './useService'
import { pageVars } from '../../../pages/const/pageVars'

const { codeText, headerText, showWarning } = pageVars.SERVICES

const pageSettings = {
  showWarning: showWarning || false,
  codeText: codeText || 'pageCodeText',
  headerText: headerText || 'pageHeaderText'
}

const ServiceSummary = () => {
  let types = []
  const defaultFetchParameter = {
    sort: '+name',
    page: 0,
    per_page: 20
  }
  const {
    bulkUpdateServicesCallBack,
    typeIdToDisplayName,
    listServiceTypes,
    listServiceCategories,
    listServices,
  } = useService()

  const {
    editMode,
    setEditMode,
    isSnackbarOpen,
    setIsSnackbarOpen,
    deletionChanges,
    deleteCallBack,
    activationChanges,
    activationCallBack,
    detailCallBack,
    addCallBack,
    handSaveCallback,
    isGridDirty
  } = useGridWrapper(
    pageSettings.codeText,
    bulkUpdateServicesCallBack,
    pageSettings.showWarning
  )

  const visibleColumns = [
    { field: 'name', headerName: 'Name', width: 250, sortable: true },
    {
      field: 'category',
      headerName: 'Category',
      width: 150,
      sortable: true
    },
    {
      field: 'type',
      headerName: 'Service Type',
      width: 200,
      sortable: true
    },
    {
      field: 'active',
      headerName: 'Status',
      width: 200,
      sortable: true,
      isToggle: true
    }
  ]

  const fetchCallBack = async arg => {
    // NOTE,
    // This is NOT how REACT is supposed to work. Due to the unfortunate
    // bad architecture of a previous UI team, we've had to do a bunch
    // of sub-optimal workarounds ahead of a rewrite.
    const [respServices, serviceTypes, serviceCategories] = await Promise.all([
      listServices(arg),
      listServiceTypes(),
      listServiceCategories()
    ]) 

    types = serviceTypes ?? []
    
    const {
      data: { data, pagination, sort } = {
        data: [],
        pagination: {},
        sort: {}
      },
      isError,
      isLoading,
      isFetching
    } = respServices

    // transform the server-provided array for display
    const rows = []
    data.forEach(one => {
      rows.push({
        id: one.id, //please note, the underlying datagrid assumes the id column is always called id
        name: one.name,
        category: serviceCategories.find(c => c.id === one.category_id)?.name,
        type: serviceTypes.find(t => t.id === one.type_id)?.name,
        active: one.suspended_at ? false : true
      })
    })

    return {
      newRows: rows,
      newPagination: pagination,
      newSort: sort,
      newLoading: isLoading || isFetching,
      newError: isError
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div style={{ height: '100%', width: '100%' }}>
        <GridWrapper
          header={pageSettings.headerText}
          containedEntityType={'NA'}
          editMode={editMode}
          setEditMode={setEditMode}
          isSnackbarOpen={isSnackbarOpen}
          setIsSnackbarOpen={setIsSnackbarOpen}
          isGridDirty={isGridDirty}
          addCallBack={addCallBack}
          listOfTypes={types}
          typeToTypeDisplayName={typeIdToDisplayName}
          handleSave={handSaveCallback}
        >
          <GenericGrid
            pageCodeText={pageSettings.codeText}
            initialFetchParameters={defaultFetchParameter}
            visibleColumns={visibleColumns}
            editMode={editMode}
            fetchCallBack={fetchCallBack}
            detailCallBack={detailCallBack}
            deleteCallBack={deleteCallBack}
            activationCallBack={activationCallBack}
            deletionChanges={deletionChanges}
            activationChanges={activationChanges}
            showWarning={pageSettings.showWarning}
          />
        </GridWrapper>
      </div>
    </div>
  )
}
export default ServiceSummary
